import { useState, useEffect } from 'react';
import { pullDraft, saveDraft, clearDraft } from '../Loaders/draftMessagesCache';

/**
 * Hook to manage draft messages for a chat
 * @param {string} chatId - The chat ID to manage drafts for
 * @returns {[string, (text: string) => void, () => void]} Draft text, setDraft function, clearDraft function
 */
export default function useDraft(chatId) {
  const [draft, setDraftState] = useState('');

  // Load draft on mount
  useEffect(() => {
    if (chatId) {
      const savedDraft = pullDraft(chatId);
      if (savedDraft) {
        setDraftState(savedDraft);
      }
    }
  }, [chatId]);

  const setDraft = (text) => {
    setDraftState(text);
    if (chatId) {
      saveDraft(chatId, text);
    }
  };

  const clear = () => {
    setDraftState('');
    if (chatId) {
      clearDraft(chatId);
    }
  };

  return [draft, setDraft, clear];
}
